import type {Values} from "@wix/devzai-utils-common";

export const DoppeAutoServiceType = {
    Latest: 'Latest',
    Categories: 'Categories',
} as const;

export type DoppeAutoServiceType = Values<typeof DoppeAutoServiceType>;